import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Logout } from '@app/core/user/store/actions/user.actions';
import { IAppState } from '@app/store';
import { Store } from '@ngrx/store';
import { User } from '@vestiaire/api-sdk-angular';
import { GetPaidService } from '@app/+payment/services/get-paid.service';
import { ImagesService } from '@app/shared/components/images/services/images.service';

@Component({
  selector: 'vc-profile-access',
  templateUrl: './profile-access.component.html',
  styleUrls: ['./profile-access.component.scss']
})
export class ProfileAccessComponent implements OnInit, OnChanges {
  public userIsLogged = false;
  @Input()
  userInfo: User;
  @Input()
  userWallet: any;
  @Input()
  needGetPaidAction: boolean;
  @Output()
  resetBox = new EventEmitter();

  walletAmount: string;
  hyperWalletIsActive = false;

  constructor(private store$: Store<IAppState>, private getPaidService: GetPaidService) {}

  ngOnInit() {
    this.getPaidService.featureIsActive().subscribe({ next: res => (this.hyperWalletIsActive = res) });
  }

  getImage(path) {
    return ImagesService.buildUrl(path, { w: 40, h: 40, fit: 'crop' });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.userWallet) {
      this.userWallet.subscribe(
        res => {
          if (res) {
            if (res.balance && res.balance.formatted && res.balance.cents > 0) {
              this.walletAmount = res.balance.formatted;
            }
          }
        },
        () => {
          /* silently error */
        }
      );
    }
  }

  logout() {
    this.store$.dispatch(new Logout());
    this.resetBox.emit({
      value: true
    });
  }
}
